import { getAllFleets } from '../lib/api';
import useFleetStore from './store';

export const fetchAllPods = async (search = "") => {
  const { setAllPodData } = useFleetStore.getState();

  const payload = {
    pageNumber: 1,
    pageSize: 100,
    ...(search ? { search } : {})
  };

  try {
    const res = await getAllFleets(payload);
    setAllPodData(res?.data);
    return res?.data;
  } catch (error) {
    console.error('Failed to fetch Zones:', error);
    return null;
  }
};
